import { Button } from 'components';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { connect } from 'react-redux';

import { selectFile, useSelectionContentFlow } from '../_actions';
import { getFiles, getSelectedFileIndex, getShouldShowPopup } from '../_selectors';
import Body from './Body';
import Head from './Head';
import Navigation from './Navigation';
import Popup from './Popup';

import './styles.scss';

interface ITableFlow {
  shouldShowPopup: boolean;
  useSelectionContentFlow: () => void;
}

const TableFlow: FC<ITableFlow> = ({
  shouldShowPopup,
  useSelectionContentFlow: selectionContentFlow
}) => {
  const t = useTranslations();

  return (
    <div>
      <Navigation showFileName />
      <div style={{ position: 'relative' }} id="ordering-form-table-wrapper" className="mt-4">
        {shouldShowPopup && <Popup />}
        <table className="ordering_form__table">
          <Head />
          <Body />
        </table>
      </div>
      <Navigation />
      <div className="mt-4 flex justify-center">
        <Button
          label={t('ordering_form.back_to_selection')}
          onClick={selectionContentFlow}
          size="medium"
          variant="text"
        />
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    files: getFiles(state),
    selectedFileIndex: getSelectedFileIndex(state),
    shouldShowPopup: getShouldShowPopup(state)
  }),
  { useSelectionContentFlow, selectFile }
)(TableFlow);
